var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerlauf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Verlauf__Icn/40px/Verlauf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Verlauf__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Verlauf__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,8 C26.627417,8 32,13.372583 32,20 C32,26.627417 26.627417,32 20,32 C13.4745433,32 8.16560725,26.7914556 8.00379986,20.3049748 L8,20 L10,20 C10,25.5228475 14.4771525,30 20,30 C25.5228475,30 30,25.5228475 30,20 C30,14.4771525 25.5228475,10 20,10 C17.3649404,10 14.8987215,11.0243375 13.0574813,12.8022159 L15.5825195,12.8027344 L15.5825195,14.8027344 L9.58251953,14.8027344 L9.58251953,8.80273437 L11.5825195,8.80273437 L11.5818061,11.4477639 C13.799531,9.26307596 16.7975412,8 20,8 Z M19,21.5671387 L19,13.5671387 L21,13.5671387 L21,19.567 L25,19.5671387 L25,21.5671387 L19,21.5671387 Z",
    id: ".._.._src_svg_Icn_40px_Verlauf__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerlauf);
export default __webpack_public_path__ + "static/media/Verlauf.2836a51ea76c837640d89433c3dbd2e1.svg";
export { ForwardRef as ReactComponent };